import _ from 'lodash';
import { DateTime } from 'luxon';

export const displayDateString = (date: string | Date, showTime: boolean) => {
  const format = showTime ? 'MM-dd-yyyy, HH:mm' : 'MM-dd-yyyy';
  if (_.isNil(date)) return 'N/A';
  if (typeof date === 'string') {
    return DateTime.fromISO(date).toFormat(format);
  } else if (typeof date === 'object') {
    return DateTime.fromJSDate(date).toFormat(format);
  }
  return 'Invalid Date';
};
